import { createAction, createReducer } from '@reduxjs/toolkit';
import { IApiType } from './interface/apiInterface';
import { IInitialState } from './interface/reduxInterface';

const INITIAL_STATE: IInitialState = {
  isActive: false,
  isLoading: false,
  gotSuccess: false,
  gotError: false,
  dateSearch: {
    start: '',
    end: '',
  },
  fiducia: {
    tipo: '',
    relatorio: {
      saldo: {
        inicial: 0,
        final: 0,
      },
      teds: {
        enviadas: {
          qtd: 0,
          valor: 0,
        },
        recebidas: {
          qtd: 0,
          valor: 0,
        },
        path_analitico: '',
      },
      tevs: {
        movimentadas: {
          qtd: 0,
          valor: 0,
        },
        path_analitico: '',
      },
      tarifas_pagas: {
        pagas: {
          // Pagas de TIB e SLB
          qtd: 0,
          valor: 0,
        },
        pagas_transf: {
          // Pagas de Pix e TED
          qtd: 0,
          valor: 0,
        },
        path_analitico: '',
        path_analitico_transf: '',
      },
      servicos: {
        pagamentos: {
          qtd: 0,
          valor: 0,
        },
        recarga: {
          qtd: 0,
          valor: 0,
        },
        path_analitico: '',
      },
      bancarizacao: {
        enviadas: {
          qtd: 0,
          valor: 0,
        },
        recebidas: {
          qtd: 0,
          valor: 0,
        },
        path_analitico: '',
      },
      boletos_liquidados: {
        liquidados: {
          // Boletos liquidados de clientes
          qtd: 0,
          valor: 0,
        },
        liquidados_fiducia: {
          // Boletos liquidados das contas Fidúcia
          qtd: 0,
          valor: 0,
        },
        path_analitico: '',
        path_analitico_fiducia: '',
      },
      parceiros: {
        tarifa_recebidas: {
          qtd: 0,
          valor: 0,
        },
        path_analitico: '',
      },
      fiducia: {
        tarifa_recebidas: {
          qtd: 0,
          valor: 0,
        },
        path_analitico: '',
      },
    },
  },
  terceiros: {
    tipo: '',
    relatorio: {
      saldo: {
        inicial: 0,
        final: 0,
      },
      teds: {
        enviadas: {
          qtd: 0,
          valor: 0,
        },
        recebidas: {
          qtd: 0,
          valor: 0,
        },
        path_analitico: '',
      },
      tevs: {
        movimentadas: {
          qtd: 0,
          valor: 0,
        },
        path_analitico: '',
      },
      tarifas_pagas: {
        pagas: {
          // Tarifas pagas a conta de terceiras
          qtd: 0,
          valor: 0,
        },
        pagas_fiducia: {
          // Tarifas pagas a conta da Fidúcia
          qtd: 0,
          valor: 0,
        },
        path_analitico: '',
        path_analitico_fiducia: '',
      },
      servicos: {
        pagamentos: {
          qtd: 0,
          valor: 0,
        },
        recarga: {
          qtd: 0,
          valor: 0,
        },
        path_analitico: '',
      },
      bancarizacao: {
        enviadas: {
          qtd: 0,
          valor: 0,
        },
        recebidas: {
          qtd: 0,
          valor: 0,
        },
        path_analitico: '',
      },
      boletos_liquidados: {
        liquidados: {
          qtd: 0,
          valor: 0,
        },
        path_analitico: '',
      },
      parceiros: {
        tarifa_recebidas: {
          // Tarifas recebidos do parceiro WL
          qtd: 0,
          valor: 0,
        },
        pagamento_recebidas: {
          // Pagamentos recebidos do parceiro WL
          qtd: 0,
          valor: 0,
        },
        path_analitico: '',
        path_analitico_pagamento: '',
      },
      fiducia: {
        tarifa_recebidas: 0,
        path_analitico: '',
      },
    },
  },
};

export const getAccountingReportFromApi = createAction(
  '@accountingApp/GET_ACCOUNTING_REPORT_FROM_API'
);
export const gotAccountingReportFromApi = createAction<any>(
  '@accountingApp/GOT_ACCOUNTING_REPORT_FROM_API'
);
export const gotErrorFromAccountingReportApi = createAction(
  '@accountingApp/GOT_ERROR_FROM_ACCOUNTING_REPORT_API'
);

const accountingAppReducer = createReducer(INITIAL_STATE, {
  [getAccountingReportFromApi.type]: (state) => ({
    ...state,
    isActive: false,
    isLoading: true,
    gotSuccess: false,
    gotError: false,
  }),

  [gotAccountingReportFromApi.type]: (state, action: IApiType) => ({
    ...state,
    isActive: true,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    dateSearch: {
      start: action.payload.data_de_pesquisa.de,
      end: action.payload.data_de_pesquisa.ate,
    },
    fiducia: {
      tipo: action.payload.fiducia.tipo,
      relatorio: {
        saldo: {
          inicial: action.payload.fiducia.relatorio.saldo.inicial,
          final: action.payload.fiducia.relatorio.saldo.final,
        },
        teds: {
          enviadas: {
            qtd: action.payload.fiducia.relatorio.teds.enviadas.qtd,
            valor: action.payload.fiducia.relatorio.teds.enviadas.valor,
          },
          recebidas: {
            qtd: action.payload.fiducia.relatorio.teds.recebidas.qtd,
            valor: action.payload.fiducia.relatorio.teds.recebidas.valor,
          },
          path_analitico: action.payload.fiducia.relatorio.teds.path_analitico,
        },
        tevs: {
          movimentadas: {
            qtd: action.payload.fiducia.relatorio.tevs.movimentadas.qtd,
            valor: action.payload.fiducia.relatorio.tevs.movimentadas.valor,
          },
          path_analitico: action.payload.fiducia.relatorio.tevs.path_analitico,
        },
        tarifas_pagas: {
          pagas: {
            // Pagas de TIB e SLB
            qtd: action.payload.fiducia.relatorio.tarifas_pagas.pagas.qtd,
            valor: action.payload.fiducia.relatorio.tarifas_pagas.pagas.valor,
          },
          pagas_transf: {
            // Pagas de Pix e TED
            qtd: action.payload.fiducia.relatorio.tarifas_pagas.pagas_transf
              .qtd,
            valor:
              action.payload.fiducia.relatorio.tarifas_pagas.pagas_transf.valor,
          },
          path_analitico:
            action.payload.fiducia.relatorio.tarifas_pagas.path_analitico,
          path_analitico_transf:
            action.payload.fiducia.relatorio.tarifas_pagas
              .path_analitico_transf,
        },
        servicos: {
          pagamentos: {
            qtd: action.payload.fiducia.relatorio.servicos.pagamentos.qtd,
            valor: action.payload.fiducia.relatorio.servicos.pagamentos.valor,
          },
          recarga: {
            qtd: action.payload.fiducia.relatorio.servicos.recarga.qtd,
            valor: action.payload.fiducia.relatorio.servicos.recarga.valor,
          },
          path_analitico:
            action.payload.fiducia.relatorio.servicos.path_analitico,
        },
        bancarizacao: {
          enviadas: {
            qtd: action.payload.fiducia.relatorio.bancarizacao.enviadas.qtd,
            valor: action.payload.fiducia.relatorio.bancarizacao.enviadas.valor,
          },
          recebidas: {
            qtd: action.payload.fiducia.relatorio.bancarizacao.recebidas.qtd,
            valor:
              action.payload.fiducia.relatorio.bancarizacao.recebidas.valor,
          },
          path_analitico:
            action.payload.fiducia.relatorio.bancarizacao.path_analitico,
        },
        boletos_liquidados: {
          liquidados: {
            // Boletos liquidados de clientes
            qtd: action.payload.fiducia.relatorio.boletos_liquidados.liquidados
              .qtd,
            valor:
              action.payload.fiducia.relatorio.boletos_liquidados.liquidados
                .valor,
          },
          liquidados_fiducia: {
            // Boletos liquidados das contas Fidúcia
            qtd: action.payload.fiducia.relatorio.boletos_liquidados
              .liquidados_fiducia.qtd,
            valor:
              action.payload.fiducia.relatorio.boletos_liquidados
                .liquidados_fiducia.valor,
          },
          path_analitico:
            action.payload.fiducia.relatorio.boletos_liquidados.path_analitico,
          path_analitico_fiducia:
            action.payload.fiducia.relatorio.boletos_liquidados
              .path_analitico_fiducia,
        },
        parceiros: {
          tarifa_recebidas: {
            qtd: action.payload.fiducia.relatorio.parceiros.tarifa_recebidas
              .qtd,
            valor:
              action.payload.fiducia.relatorio.parceiros.tarifa_recebidas.valor,
          },
          path_analitico:
            action.payload.fiducia.relatorio.parceiros.path_analitico,
        },
        fiducia: {
          tarifa_recebidas: {
            qtd: action.payload.fiducia.relatorio.fiducia.tarifa_recebidas.qtd,
            valor:
              action.payload.fiducia.relatorio.fiducia.tarifa_recebidas.valor,
          },
          path_analitico:
            action.payload.fiducia.relatorio.fiducia.path_analitico,
        },
      },
    },
    terceiros: {
      tipo: action.payload.terceiros.tipo,
      relatorio: {
        saldo: {
          inicial: action.payload.terceiros.relatorio.saldo.inicial,
          final: action.payload.terceiros.relatorio.saldo.final,
        },
        teds: {
          enviadas: {
            qtd: action.payload.terceiros.relatorio.teds.enviadas.qtd,
            valor: action.payload.terceiros.relatorio.teds.enviadas.valor,
          },
          recebidas: {
            qtd: action.payload.terceiros.relatorio.teds.recebidas.qtd,
            valor: action.payload.terceiros.relatorio.teds.recebidas.valor,
          },
          path_analitico:
            action.payload.terceiros.relatorio.teds.path_analitico,
        },
        tevs: {
          movimentadas: {
            qtd: action.payload.terceiros.relatorio.tevs.movimentadas.qtd,
            valor: action.payload.terceiros.relatorio.tevs.movimentadas.valor,
          },
          path_analitico:
            action.payload.terceiros.relatorio.tevs.path_analitico,
        },
        tarifas_pagas: {
          pagas: {
            // Tarifas pagas a conta de terceiras
            qtd: action.payload.terceiros.relatorio.tarifas_pagas.pagas.qtd,
            valor: action.payload.terceiros.relatorio.tarifas_pagas.pagas.valor,
          },
          pagas_fiducia: {
            // Tarifas pagas a conta da Fidúcia
            qtd: action.payload.terceiros.relatorio.tarifas_pagas.pagas_fiducia
              .qtd,
            valor:
              action.payload.terceiros.relatorio.tarifas_pagas.pagas_fiducia
                .valor,
          },
          path_analitico:
            action.payload.terceiros.relatorio.tarifas_pagas.path_analitico,
          path_analitico_fiducia:
            action.payload.terceiros.relatorio.tarifas_pagas
              .path_analitico_fiducia,
        },
        servicos: {
          pagamentos: {
            qtd: action.payload.terceiros.relatorio.servicos.pagamentos.qtd,
            valor: action.payload.terceiros.relatorio.servicos.pagamentos.valor,
          },
          recarga: {
            qtd: action.payload.terceiros.relatorio.servicos.recarga.qtd,
            valor: action.payload.terceiros.relatorio.servicos.recarga.valor,
          },
          path_analitico:
            action.payload.terceiros.relatorio.servicos.path_analitico,
        },
        bancarizacao: {
          enviadas: {
            qtd: action.payload.terceiros.relatorio.bancarizacao.enviadas.qtd,
            valor:
              action.payload.terceiros.relatorio.bancarizacao.enviadas.valor,
          },
          recebidas: {
            qtd: action.payload.terceiros.relatorio.bancarizacao.recebidas.qtd,
            valor:
              action.payload.terceiros.relatorio.bancarizacao.recebidas.valor,
          },
          path_analitico:
            action.payload.terceiros.relatorio.bancarizacao.path_analitico,
        },
        boletos_liquidados: {
          liquidados: {
            qtd: action.payload.terceiros.relatorio.boletos_liquidados
              .liquidados.qtd,
            valor:
              action.payload.terceiros.relatorio.boletos_liquidados.liquidados
                .valor,
          },
          path_analitico:
            action.payload.terceiros.relatorio.boletos_liquidados
              .path_analitico,
        },
        parceiros: {
          tarifa_recebidas: {
            // Tarifas recebidos do parceiro WL
            qtd: action.payload.terceiros.relatorio.parceiros.tarifa_recebidas
              .qtd,
            valor:
              action.payload.terceiros.relatorio.parceiros.tarifa_recebidas
                .valor,
          },
          pagamento_recebidas: {
            // Pagamentos recebidos do parceiro WL
            qtd: action.payload.terceiros.relatorio.parceiros
              .pagamento_recebidas.qtd,
            valor:
              action.payload.terceiros.relatorio.parceiros.pagamento_recebidas
                .valor,
          },
          path_analitico:
            action.payload.terceiros.relatorio.parceiros.path_analitico,
          path_analitico_pagamento:
            action.payload.terceiros.relatorio.parceiros
              .path_analitico_pagamento,
        },
        fiducia: {
          tarifa_recebidas:
            action.payload.terceiros.relatorio.fiducia.tarifa_recebidas.valor,
          path_analitico:
            action.payload.terceiros.relatorio.fiducia.path_analitico,
        },
      },
    },
  }),

  [gotErrorFromAccountingReportApi.type]: (state) => ({
    ...state,
    isActive: false,
    isLoading: false,
    gotSuccess: false,
    gotError: true,
  }),
});

export default accountingAppReducer;
